import { render, staticRenderFns } from "./InteractiveRoom.vue?vue&type=template&id=f957a7bc"
import script from "./InteractiveRoom.vue?vue&type=script&lang=js"
export * from "./InteractiveRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports